const galleryPage = {
  content: {
    py: [5]
  }
};

export default galleryPage;
